import { cva } from "@design-system/utils";

export const linkVariants = cva("", {
  variants: {
    variant: {
      default: "",
      hover: "hover:underline focus-visible:underline",
      underline: "underline underline-offset-4",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});
